import { useLingui } from '@lingui/react/macro';
import { type CategoryKey } from '@worldcoo/shared/core';

/** The Figma editorial order; `categoriesKeys` cannot be resorted, since its index is the stored number. */
export const CATEGORY_ORDER = [
	'health',
	'environment',
	'education',
	'habitat',
	'feeding',
	'humanRights',
	'emergency',
	'basicNeeds',
] as const satisfies readonly CategoryKey[];

/** One source: typed per form, `habitat` read "Social Inclusion" in one place and not the next. */
export function useCategoryLabels(): Record<CategoryKey, string> {
	const { t } = useLingui();
	return {
		health: t`Health`,
		environment: t`Environment`,
		education: t`Education & Job Insertion`,
		habitat: t`Social Inclusion`,
		feeding: t`Hunger & Food Security`,
		humanRights: t`Human Rights`,
		emergency: t`Emergencies`,
		basicNeeds: t`Water & Energy`,
	};
}

export function useCategoryOptions(): { value: CategoryKey; label: string }[] {
	const labels = useCategoryLabels();
	return CATEGORY_ORDER.map((value) => ({ value, label: labels[value] }));
}
